// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_bc7633e","createTournModal":"_79e36c8","container":"_eda97a4","body":"_85573c3","quickCreate":"_cbc947e","headerBack":"_9300c6e","content":"_6a69921"};